import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import "moment/locale/pt-br";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

// Ícones ultra-avançados
const ARIcon = () => (<svg width="20" height="20" fill="currentColor"><circle cx="10" cy="10" r="9"/><text x="5" y="14" fontSize="8" fill="#fff">AR</text></svg>);
const ChallengeIcon = () => (<svg width="20" height="20" fill="currentColor"><rect x="2" y="2" width="16" height="16" rx="3"/><text x="4" y="14" fontSize="8" fill="#fff">🏆</text></svg>);
const LiveIcon = () => (<svg width="20" height="20" fill="red"><circle cx="10" cy="10" r="9"/><text x="3" y="14" fontSize="7" fill="#fff">LIVE</text></svg>);
const PrivacyIcon = () => (<svg width="20" height="20" fill="currentColor"><rect x="3" y="6" width="14" height="9" rx="2"/><circle cx="10" cy="10" r="2" fill="#fff"/></svg>);
const NotificationIcon = () => (<svg width="20" height="20" fill="currentColor"><path d="M10 18c.83 0 1.5-.67 1.5-1.5h-3c0 .83.67 1.5 1.5 1.5zm4.5-4.5V9c0-2.3-1.22-4.23-3.38-4.74V4c0-.62-.5-1.12-1.12-1.12-.62 0-1.12.5-1.12 1.12v.26C6.72 4.77 5.5 6.7 5.5 9v4.5L4.12 14.88c-.1.1-.22.25-.22.45V16h12.2v-.67c0-.2-.12-.35-.22-.45L14.5 13.5z"/></svg>);
const ModerationIcon = () => (<svg width="20" height="20" fill="orange"><rect x="2" y="2" width="16" height="16" rx="2"/><text x="3" y="14" fontSize="7" fill="#fff">MOD</text></svg>);
const APIIcon = () => (<svg width="20" height="20" fill="blue"><rect x="2" y="2" width="16" height="16" rx="2"/><text x="4" y="14" fontSize="7" fill="#fff">API</text></svg>);

export default function ThreadsFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => setEditingPost(post);
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
  };

  // Handlers ultra-avançados
  const handleAR = (post) => alert("Aplicar efeitos AR neste thread");
  const handleChallenge = (post) => alert("Participar de desafio");
  const handleLiveStream = (post) => alert("Iniciar live");
  const handlePrivacy = (post) => alert("Configurar privacidade");
  const handleNotifications = (post) => alert("Gerenciar notificações");
  const handleModeration = (post) => alert("Ver moderação");
  const handleAPIIntegration = (post) => alert("Integrar com APIs externas");

  const filters = [
    { id: "all", name: "Para você" },
    { id: "following", name: "Seguindo" },
    { id: "popular", name: "Popular" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/threads?page=${pageNum}&limit=20`;
      if (filter !== "all") url += `&filter=${filter}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching threads:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [filter]);

  if (loading && posts.length === 0) {
    return <div className="threads_feed_loading"><div className="threads_loader"></div><span>Carregando threads...</span></div>;
  }

  return (
    <div className="threads_feed">
      {filters.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {filters.map((filterItem) => (
              <button
                key={filterItem.id}
                className={`filter_btn ${filter === filterItem.id ? "active" : ""}`}
                onClick={() => setFilter(filterItem.id)}
              >
                {filterItem.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="threads_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
          </svg>
          <h3>Nenhuma thread encontrada</h3>
          <p>Seja o primeiro a criar uma thread!</p>
        </div>
      ) : (
        <div className="threads_list">
          {posts.map((post) => (
            <div key={post._id} className="thread_item">
              <Link to={`/profile/${post.user.username}`} className="thread_avatar">
                <img src={post.user.picture} alt="" />
              </Link>
              <div className="thread_content">
                <div className="thread_header">
                  <Link to={`/profile/${post.user.username}`} className="thread_username">
                    {post.user.username}
                  </Link>
                  <span className="thread_time">
                    <Moment fromNow locale="pt-br">{post.createdAt}</Moment>
                  </span>
                </div>
                <p className="thread_text">{post.threadsData?.content || post.text}</p>
                {post.images?.length > 0 && (
                  <div className={`thread_images ${post.images.length > 1 ? "multiple" : ""}`}>
                    {post.images.slice(0, 4).map((img, i) => (
                      <img key={i} src={img.url || img} alt="" />
                    ))}
                  </div>
                )}
                <div className="thread_actions">
                  <button className="thread_action">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                    </svg>
                    <span>{post.threadsData?.likes || 0}</span>
                  </button>
                  <button className="thread_action">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/>
                    </svg>
                    <span>{post.threadsData?.replies || 0}</span>
                  </button>
                  <button className="thread_action">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"/>
                    </svg>
                    <span>{post.threadsData?.reposts || 0}</span>
                  </button>
                  <button className="thread_action">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"/>
                    </svg>
                  </button>
                  <FeedPostMenu
                    post={post}
                    onEdit={handleEditPost}
                    onPostDeleted={handlePostDeleted}
                  />

                  {/* Botões Ultra-Avançados */}
                  <button onClick={() => handleAR(post)} className="thread_action" title="AR">
                    <ARIcon />
                  </button>
                  <button onClick={() => handleChallenge(post)} className="thread_action" title="Desafio">
                    <ChallengeIcon />
                  </button>
                  <button onClick={() => handleLiveStream(post)} className="thread_action" title="Live">
                    <LiveIcon />
                  </button>
                  <button onClick={() => handlePrivacy(post)} className="thread_action" title="Privacidade">
                    <PrivacyIcon />
                  </button>
                  <button onClick={() => handleNotifications(post)} className="thread_action" title="Notificações">
                    <NotificationIcon />
                  </button>
                  <button onClick={() => handleModeration(post)} className="thread_action" title="Moderação">
                    <ModerationIcon />
                  </button>
                  <button onClick={() => handleAPIIntegration(post)} className="thread_action" title="API">
                    <APIIcon />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="threads_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais"}
          </button>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
